"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_dom_1 = __importDefault(require("react-dom"));
const client_1 = require("@apollo/client");
const error_1 = require("@apollo/client/link/error");
const context_1 = require("@apollo/client/link/context");
const react_favicon_1 = __importDefault(require("react-favicon"));
const en_json_1 = __importDefault(require("@shopify/polaris/locales/en.json"));
const polaris_1 = require("@shopify/polaris");
const cache_1 = require("./cache");
const queryDefinitions_1 = require("./queryDefinitions");
const Sentry = __importStar(require("./Sentry"));
const Root_1 = __importDefault(require("./Root"));
const AccountContext_1 = require("./contexts/AccountContext");
const favicon_32x32_png_1 = __importDefault(require("./assets/images/favicon-32x32.png"));
require("./assets/styles/base.css");
require("./assets/styles/reset.css");
require("@shopify/polaris/build/esm/styles.css");
Sentry.init();
// eslint-disable-next-line prefer-const
let client;
const httpLink = (0, client_1.createHttpLink)({
    uri: env.GRAPHQL_URL
});
const authLink = (0, context_1.setContext)((_operation, { headers }) => {
    // get the authentication token from local storage if it exists
    const token = localStorage.getItem('token');
    // return the headers to the context so httpLink can read them
    return {
        headers: Object.assign(Object.assign({}, headers), { authorization: token ? `Bearer ${token}` : undefined })
    };
});
function handleLogout() {
    var _a;
    (0, cache_1.isLoggedInVar)(false);
    (_a = AccountContext_1.AccountContextRef.current) === null || _a === void 0 ? void 0 : _a.setAccount(null);
    localStorage.removeItem('token');
    localStorage.removeItem('account');
    client.cache.reset({ discardWatches: true });
}
// Log any GraphQL errors or network error that occurred
const errorLink = (0, error_1.onError)(({ graphQLErrors, networkError, operation }) => {
    if (graphQLErrors) {
        graphQLErrors.forEach(({ message, locations, path }) => {
            // eslint-disable-next-line no-console
            console.error(`[GraphQL error]: Message: ${message}, Location: ${JSON.stringify(locations)}, Path: ${path}, Operation: ${operation.operationName}`);
            Sentry.captureException(message, { extra: { locations, path } });
        });
    }
    if (networkError) {
        if (networkError.message.match(/code 401/)) {
            handleLogout();
        }
        // eslint-disable-next-line no-console
        console.error(`[Network error]: ${networkError}`);
    }
});
client = new client_1.ApolloClient({
    link: errorLink.concat(authLink).concat(httpLink),
    cache: cache_1.cache,
    typeDefs: queryDefinitions_1.typeDefs
});
const RootWithApollo = () => {
    const { data: loginData } = (0, client_1.useQuery)(queryDefinitions_1.IS_LOGGED_IN);
    return react_1.default.createElement(Root_1.default, { isLoggedIn: loginData.isLoggedIn, onLogout: handleLogout });
};
const root = document.querySelector('#root');
react_dom_1.default.render(react_1.default.createElement(AccountContext_1.AccountProvider, null,
    react_1.default.createElement(client_1.ApolloProvider, { client: client },
        react_1.default.createElement(polaris_1.AppProvider, { i18n: en_json_1.default },
            react_1.default.createElement(react_favicon_1.default, { url: favicon_32x32_png_1.default }),
            react_1.default.createElement(RootWithApollo, null)))), root);
